// 정책 고지 읽기 — Firestore config/policyNotices 문서의 map 필드 1개 = 고지 1건 (2026-09-14, 구 환자앱 종료 고지)
// 근거: docs/법무보완_구환자앱폐기_2026-09-14.md §2(종료일 30일 전 고지·채널별 게시일 기록). 문안 정본은 법적보안이
// docs/구환자앱_종료고지_2026-09-14.md로 확정 중 — 화면은 문서 값을 그대로 보여 주므로 문안 교체는 Firestore만 고치면 된다.
// 경로 가정: 요청 표기 `config/policyNotices/patientapp_shutdown`은 문서 경로로 홀수 세그먼트라 성립하지 않아
//   **문서 config/policyNotices 의 필드 patientapp_shutdown(map)** 으로 해석했다. rules: config/policyNotices get 공개.
// 필드: { postedAt(Timestamp|ms), endsAt·purgeAt·purgeDueAt(Timestamp|ms|'YYYY-MM-DD'), title, body, hash }
//   purgeAt = 파기 개시일, purgeDueAt = 파기 완료 기한 (docs/구환자앱_종료고지_2026-09-14.md §4-1)
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export const NOTICE_DOC_ID = 'policyNotices';
export const PATIENTAPP_SHUTDOWN_KEY = 'patientapp_shutdown';
export { LBS_TERMS_V11_KEY } from '../config/policyNotices';

const toDate = (v) => {
    if (!v) return null;
    if (v.toDate) return v.toDate();
    const d = typeof v === 'number' ? new Date(v) : (v._seconds ? new Date(v._seconds * 1000) : new Date(v));
    return Number.isNaN(d.getTime()) ? null : d;
};

// 없으면 null(배너 미표시). 읽기 실패도 null이지만 console.error로 남긴다(조용한 실패 금지)
export async function getPolicyNotice(key = PATIENTAPP_SHUTDOWN_KEY) {
    try {
        const snap = await getDoc(doc(db, 'config', NOTICE_DOC_ID));
        if (!snap.exists()) return null;
        const n = snap.data()?.[key];
        if (!n || typeof n !== 'object') return null;
        if (!n.title && !n.body) return null;
        return {
            key,
            title: n.title || '',
            body: n.body || '',
            hash: n.hash || '',
            kind: n.kind || '',
            version: n.version || '',
            link: n.link || '',
            effectiveAt: toDate(n.effectiveAt),   // 시행일 — 배너 자동 내림 기준(위치약관 v1.1 §9-3)
            postedAt: toDate(n.postedAt),
            endsAt: toDate(n.endsAt),
            purgeAt: toDate(n.purgeAt),
            purgeDueAt: toDate(n.purgeDueAt),
        };
    } catch (e) {
        console.error('[policyNotices] 고지 문서 읽기 실패', key, e?.code || e);
        return null;
    }
}
